// extracted by css-extract-rspack-plugin
export default {"registrationStatus":"OfficialDetails_registrationStatus__7wV67"};